import React from 'react';

/**
 * This component is used for the journey banner (smartbanner) from branch.io
 * If you have a fixed or absolute positioned element on your site,
 * you will need to insert this div to prevent the banner from overlapping.
 * Insert this component as the first child of your element.
 * https://docs.branch.io/web/journeys/#prevent-overlap-between-top-banners-and-persistent-navigation-bars
 */
export default function SmartbannerOverlapFix() {
  return <div className="branch-journeys-top" />;
}
